import { render, staticRenderFns } from "./TriggerListInfo.vue?vue&type=template&id=147480cf&"
import script from "./TriggerListInfo.vue?vue&type=script&lang=js&"
export * from "./TriggerListInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports